import React from 'react'
import { withRouter, Prompt } from 'react-router-dom'
import { getPreventNavigationElement } from 'lib/helpers'

/**
 * Alert user with prompt if trying to leave page while
 * "data-prevent-navigation" attribute exists in any element within page.
 *
 * Currently only counts pathname changes as page changes. #hash and ?query is ignored.
 */
const ExtendedFormikPrompt = ({ location }) => {
    return (
        <Prompt
            when={true}
            message={(targetLocation) => {
                if (targetLocation.pathname !== location.pathname) {
                    const element = getPreventNavigationElement()
                    return !element || element.message
                }

                return true
            }}
        />
    )
}

export default withRouter(ExtendedFormikPrompt)
